






import { defineComponent } from '@nuxtjs/composition-api';
import SfTableRow from './SfTableRow.vue';
import SfTableData from './SfTableData.vue';
import SfTableHeader from './SfTableHeader.vue';
import SfTableHeading from './SfTableHeading.vue';

export default defineComponent({
  name: 'SfTable',
  components: {
    SfTableRow,
    SfTableData,
    SfTableHeader,
    SfTableHeading,
  },
  provide() {
    const table = {};
    Object.defineProperty(table, 'updateColumnsCount', {
      value: this.updateColumnsCount,
    });
    return { table };
  },
  methods: {
    updateColumnsCount(columnsCount) {
      (this.$el as any).style.setProperty(
        '--_table-column-width',
        Math.ceil(columnsCount / 2),
      );
    },
  },
});
